import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Building2, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const { loginWithSession } = useAuth();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sid = match ? decodeURIComponent(match[1]) : null;
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        await loginWithSession(sid);
        window.history.replaceState(null, "", "/");
        nav("/");
      } catch {
        nav("/login");
      }
    })();
  }, [loginWithSession, nav]);

  return (
    <div className="min-h-screen bg-navy-900 flex flex-col items-center justify-center gap-4">
      <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-gold to-gold-dark flex items-center justify-center"><Building2 className="w-6 h-6 text-navy-900" /></div>
      <Loader2 className="w-6 h-6 animate-spin text-gold" />
      <p className="text-slate-300 text-sm">Signing you in…</p>
    </div>
  );
}
